'use client';

import React, { useState, ChangeEvent } from 'react';
import { createContact } from '@/app/actions'; // Assuming actions.ts is in @/app

const SubscriberForm = ({id, source}:{id:string, source:string}) => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const modalId = id; // Unique ID for the modal and checkbox

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setIsLoading(true);

    try {
      const result = await createContact({ email, source: source });
      if (result.success) {
        setSuccess(true);
        setEmail('');
        // Keep the modal open to show success message
        // User can close it manually
      } else {
        // This case might not happen if createContact throws on failure
        setError('Subscription failed. Please try again.');
      }
    } catch (err: any) {
      setError(err.message || 'An unexpected error occurred.');
    } finally {
      setIsLoading(false);
    }
  };

  // Reset form state when modal is closed
  const handleModalToggle = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.checked) {
      // Timeout to allow closing animation
      setTimeout(() => {
        setEmail('');
        setSuccess(false);
        setError('');
        setIsLoading(false);
      }, 300); // Adjust timing if needed
    }
  };


  return (
    <>
      {/* Button to trigger the modal - uses label */}
      <label htmlFor={modalId} className="btn btn-primary">
        Subscribe to Newsletter
      </label>

      {/* Hidden checkbox to control modal state */}
      <input
        type="checkbox"
        id={modalId}
        className="modal-toggle"
        onChange={handleModalToggle}
      />

      {/* The Modal */}
      <div className="modal modal-bottom sm:modal-middle" role="dialog">
        <div className="modal-box">
          <h3 className="font-bold text-lg mb-4">Subscribe to Our Newsletter!</h3>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <p>Stay updated with our latest news and offers.</p>
            <input
              type="email"
              placeholder="Enter your email"
              className="input input-bordered w-full"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading || success}
            />
            <button
              className="btn btn-primary"
              type="submit"
              disabled={isLoading || success}
            >
              {isLoading ? <span className="loading loading-spinner"></span> : 'Subscribe'}
            </button>
            {success && <div className="text-green-500 text-center p-2 bg-green-100 rounded">Subscribed successfully!</div>}
            {error && <div className="text-red-500 text-center p-2 bg-red-100 rounded">Error: {error}</div>}
          </form>
          <div className="modal-action mt-4">
             {/* Close button using label */}
             <label htmlFor={modalId} className="btn">
                Close
             </label>
          </div>
           {/* Optional: Add top-right close button */}
           <label htmlFor={modalId} className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</label>
        </div>

         {/* Click outside to close */}
         <label className="modal-backdrop" htmlFor={modalId}>Close</label>
      </div>
    </>
  );
};

export default SubscriberForm;
